const setBlogSubscriptionCookie = [
    {
        selector: '[data-form-name=other_blog_subscription]',
        path: { filename: 'setBlogSubscriptionCookie' },
    },
    {
        selector: '[data-form-name=other_blog_subscription]',
        path: { filename: 'validateCheckboxFields' },
    },
];

export { setBlogSubscriptionCookie };
